import styled, { createGlobalStyle } from 'styled-components';
import * as colors from '../config/colors';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`

:root{
  --toastify-icon-color-success: white;
  --toastify-icon-color-error: white;
}

* {
  margin: 0;
  padding: 0;
  outline: none;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
}

body {
  background: rgb(230, 230, 230);
  color: ${colors.primaryDarkColor};
}

html, body, #root {
  height: 100%;
  overflow: hidden;
}

button {
  cursor: pointer;
  border: none;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  height: 2.2rem;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
}

body .Toastify .Toastify__toast-container .Toastify__toast--success {
  background: ${colors.successColor};
  color: white;
}

.Toastify__progress-bar--success {
  background: white;
}

body .Toastify .Toastify__toast-container .Toastify__toast--error {
  background: ${colors.errorColor};
  color: white;

}

.Toastify__progress-bar--error {
  background: white;
}
`;

export const Container = styled.section`
  max-width: 95%;
  height: 95vh;
  overflow: auto;
  margin-left: 5rem;
  margin-right: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background: #024089;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  scrollbar-width: thin;
`;

export const Form = styled.form`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  label {
  font-size: 0.7em;
  font-weight: 700;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
}

input {
  margin-bottom: 0.5rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}

select {
  margin-bottom: 0.5rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
}

select:hover {
  background-color: #ddd;
}

input:hover {
  background-color: #ddd;
  outline: none;
}

input:disabled {
  background-color: white;
}

input:disabled:hover {
  background-color: #ddd;
  outline: none;
}


button {
    background-color: white;
    width: 30%;
    color: black;
    margin-bottom: 0.5rem;
    padding: .3rem;
    font-size: medium;
}

button:hover {
    background-color: #ddd;
  }

#submit-questoes, #submit-disciplina {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  }

  a {
    background-color: white;
    height: 2.2rem;
    color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 30%;
    font-size: medium;
  }

  a:hover {
    background-color: #ddd;
  }
`;

export const Filtros = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;

  div {
    margin: 1rem 1rem;
  }

  label {
    color: white;
    cursor: pointer;
  }

  input {
    cursor: pointer;
    margin-right: 1rem;
  }
`;
